import { LegoPerformance } from "../lego-perf/LegoPerformance";
export default LegoPerformance;